// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   FaTicketAlt, FaCopy, FaCalendarAlt,
//   FaMapMarkerAlt, FaClock, FaCheckCircle,
// } from "react-icons/fa";
// import { BsTagFill } from "react-icons/bs";

// const CouponSection = () => {
//   const [coupons, setCoupons]     = useState([]);
//   const [loading, setLoading]     = useState(true);
//   const [activeIdx, setActiveIdx] = useState(0);

//   // Touch swipe
//   const touchStartX = useRef(null);
//   const isSwiping   = useRef(false);

//   useEffect(() => {
//     const fetchCoupons = async () => {
//       try {
//         const res = await axios.get(
//           "https://api.carnivalcastle.com/v1/carnivalApi/admin/coupon/getallcarnivalcoupons"
//         );
//         if (res.data.success) {
//           const now = new Date();
//           const valid = res.data.coupons.filter((c) => {
//             const exp = new Date(c.toDate);
//             return c.status === "active" && exp >= now && !isNaN(exp.getTime());
//           });
//           setCoupons(valid);
//         }
//       } catch (err) {
//         console.error("Error fetching coupons:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCoupons();
//   }, []);

//   // Auto-play every 4 s
//   useEffect(() => {
//     if (chunks.length <= 1) return;
//     const t = setInterval(() => setActiveIdx(i => (i + 1) % chunks.length), 4000);
//     return () => clearInterval(t);
//   });

//   const copyCode = (code) => {
//     navigator.clipboard.writeText(code);
//     toast.success("Coupon code copied!", { position: "top-center", autoClose: 1500 });
//   };

//   // Group into chunks of 3
//   const CHUNK = 3;
//   const chunks = [];
//   for (let i = 0; i < coupons.length; i += CHUNK) chunks.push(coupons.slice(i, i + CHUNK));

//   const prev = () => setActiveIdx(i => (i - 1 + chunks.length) % chunks.length);
//   const next = () => setActiveIdx(i => (i + 1) % chunks.length);

//   // Touch handlers
//   const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; isSwiping.current = false; };
//   const onTouchMove  = (e) => {
//     if (!touchStartX.current) return;
//     if (Math.abs(e.touches[0].clientX - touchStartX.current) > 8) { isSwiping.current = true; e.preventDefault(); }
//   };
//   const onTouchEnd = (e) => {
//     if (!touchStartX.current) return;
//     const dx = e.changedTouches[0].clientX - touchStartX.current;
//     if (isSwiping.current && Math.abs(dx) > 40) dx < 0 ? next() : prev();
//     touchStartX.current = null; isSwiping.current = false;
//   };

//   if (loading) return (
//     <div className="text-center py-5">
//       <div className="spinner-border text-primary mb-3" role="status" />
//       <p>Loading coupons...</p>
//     </div>
//   );

//   if (coupons.length === 0) return (
//     <section className="py-5 bg-light">
//       <div className="container text-center">
//         <h2 className="fw-bold mb-4" style={{ color: "#330C5F" }}>
//           <FaTicketAlt className="me-2" />Exclusive CarnivalCastle Coupons
//         </h2>
//         <div className="d-inline-block p-5 rounded-4 shadow-sm"
//           style={{ background: "linear-gradient(135deg,rgba(157,77,255,.08),rgba(255,255,255,.9))", maxWidth: 400 }}>
//           <div className="mb-3 d-flex align-items-center justify-content-center"
//             style={{ width: 100, height: 100, backgroundColor: "rgba(157,77,255,.15)", borderRadius: "50%", margin: "0 auto" }}>
//             <FaTicketAlt size={48} color="#9D4DFF" />
//           </div>
//           <h5 className="fw-semibold mt-3" style={{ color: "#40008C" }}>No Active Coupons Right Now</h5>
//           <p className="text-secondary small mt-2 mb-0">
//             Please check back later — new offers and discounts are coming soon!
//           </p>
//         </div>
//       </div>
//     </section>
//   );

//   return (
//     <section className="py-5 bg-light">
//       <div className="container">
//         <h2 className="text-center fw-bold mb-3" style={{ color: "#330C5F" }}>
//           <FaTicketAlt className="me-2" />Exclusive CarnivalCastle Coupons
//         </h2>

//         {/* ── Dot indicators ── */}
//         {chunks.length > 1 && (
//           <div className="d-flex justify-content-center gap-2 mb-4">
//             {chunks.map((_, i) => (
//               <button key={i} onClick={() => setActiveIdx(i)}
//                 style={{
//                   width: i === activeIdx ? 26 : 10, height: 10,
//                   borderRadius: 999, border: "none", padding: 0, cursor: "pointer",
//                   background: i === activeIdx ? "#9D4DFF" : "#E9DCFF",
//                   transition: "all .3s ease",
//                 }}
//               />
//             ))}
//           </div>
//         )}

//         {/* ── Slides ── */}
//         <div style={{ position: "relative", overflow: "hidden" }}
//           onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>

//           <div style={{
//             display: "flex",
//             transform: `translateX(-${activeIdx * 100}%)`,
//             transition: "transform .45s cubic-bezier(.34,1.26,.64,1)",
//             willChange: "transform",
//           }}>
//             {chunks.map((chunk, ci) => (
//               <div key={ci} style={{ minWidth: "100%", flexShrink: 0 }}>
//                 <div className="row g-4 justify-content-center">
//                   {chunk.map((coupon) => (
//                     <div key={coupon._id} className="col-md-4 d-flex justify-content-center">

//                       {/* ── Original card design ── */}
//                       <div className="coupon-ticket shadow-lg rounded-3 position-relative overflow-hidden h-100 lightdark-back">

//                         {/* Status ribbon */}
//                         <div className="position-absolute top-0 end-0 px-2 py-1 text-white fw-bold rounded-start"
//                           style={{ backgroundColor: "#28a745", fontSize: ".8rem", zIndex: 2 }}>
//                           <FaCheckCircle className="me-1" />Active
//                         </div>

//                         <div className="p-4 d-flex flex-column">
//                           <h5 className="fw-bold mb-2" style={{ color: "#40008C" }}>
//                             <BsTagFill className="me-2" />{coupon.title}
//                           </h5>
//                           <p className="text-black small mb-4">
//                             {coupon.description || "Special offer for you!"}
//                           </p>

//                           {/* Discount & Code */}
//                           <div className="text-center border rounded-3 py-3 mb-4 bg-light">
//                             <div className="fw-bold fs-5" style={{ color: "#40008C" }}>
//                               {coupon.discountType === "fixed" ? `₹${coupon.value} OFF` : `${coupon.value}% OFF`}
//                             </div>
//                             <div className="text-muted small mt-1">
//                               Use Code: <span className="fw-bold text-danger">{coupon.couponCode}</span>
//                             </div>
//                           </div>

//                           {/* Details */}
//                           <div className="coupon-details mb-4 small text-secondary flex-grow-1">
//                             <div className="d-flex justify-content-between py-1 border-bottom">
//                               <span className="fw-semibold text-dark"><FaCalendarAlt className="me-2 text-primary" />Valid Till :</span>
//                               <span className="text-black">{new Date(coupon.toDate).toLocaleDateString()}</span>
//                             </div>
//                             <div className="d-flex justify-content-between py-1 border-bottom">
//                               <span className="fw-semibold text-dark"><FaMapMarkerAlt className="me-2 text-primary" />Theaters :</span>
//                               <span className="text-black" style={{ maxWidth: 130, fontSize: ".85rem" }}>
//                                 {coupon.theaters.map(t => t.name).join(", ")}
//                               </span>
//                             </div>
//                             <div className="d-flex justify-content-between py-1">
//                               <span className="fw-semibold text-dark"><FaClock className="me-2 text-primary" />Slots :</span>
//                               <span className="text-black">{coupon.slots.join(", ")}</span>
//                             </div>
//                           </div>

//                           <button className="btn w-100 mt-auto d-flex align-items-center justify-content-center gap-2"
//                             style={{ backgroundColor: "#9D4DFF", color: "white", fontWeight: 600, borderRadius: 30 }}
//                             onClick={() => copyCode(coupon.couponCode)}>
//                             <FaCopy /> Copy Code
//                           </button>
//                         </div>

//                         <div className="perforation-top" />
//                         <div className="perforation-bottom" />
//                       </div>

//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Prev / Next arrows */}
//           {chunks.length > 1 && (
//             <>
//               <button onClick={prev} className="carousel-control-prev" type="button"
//                 style={{ width: 40, position: "absolute", top: "50%", left: 0, transform: "translateY(-50%)" }}>
//                 <span className="carousel-control-prev-icon" aria-hidden="true" style={{ filter: "invert(30%) sepia(80%) saturate(500%) hue-rotate(240deg)" }} />
//                 <span className="visually-hidden">Previous</span>
//               </button>
//               <button onClick={next} className="carousel-control-next" type="button"
//                 style={{ width: 40, position: "absolute", top: "50%", right: 0, transform: "translateY(-50%)" }}>
//                 <span className="carousel-control-next-icon" aria-hidden="true" style={{ filter: "invert(30%) sepia(80%) saturate(500%) hue-rotate(240deg)" }} />
//                 <span className="visually-hidden">Next</span>
//               </button>
//             </>
//           )}
//         </div>
//       </div>

//       <ToastContainer />

//       <style>{`
//         .coupon-ticket {
//           background: white;
//           max-width: 340px;
//           border: 2px dashed #e0e0e0;
//           position: relative;
//           transition: transform 0.3s ease;
//           display: flex;
//           flex-direction: column;
//         }
//         .coupon-ticket:hover {
//           transform: scale(1.02);
//           box-shadow: 0 8px 16px rgba(0,0,0,.12);
//         }
//         .perforation-top, .perforation-bottom {
//           position: absolute; left: 0; right: 0; height: 8px;
//           background: repeating-linear-gradient(90deg,#f8f9fa,#f8f9fa 10px,transparent 10px,transparent 20px);
//           pointer-events: none;
//         }
//         .perforation-top  { top: 0; }
//         .perforation-bottom { bottom: 0; }
//       `}</style>
//     </section>
//   );
// };

// export default CouponSection;

// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { FaTicketAlt, FaCopy, FaCalendarAlt, FaMapMarkerAlt, FaClock, FaChevronLeft, FaChevronRight } from "react-icons/fa";

// // ── Colour tokens (matches CarnivalCastle palette) ──────────────────────────
// const C = {
//   dark:      "#1a0533",
//   purple:    "#330C5F",
//   purpleMid: "#4B1280",
//   violet:    "#9D4DFF",
//   violetSoft:"rgba(157,77,255,0.18)",
//   gold:      "#FFD700",
//   goldLight: "#FFE566",
//   goldDim:   "rgba(255,215,0,0.15)",
//   white:     "#ffffff",
//   offWhite:  "rgba(255,255,255,0.85)",
//   muted:     "rgba(255,255,255,0.5)",
// };

// // ── Helpers ──────────────────────────────────────────────────────────────────
// const fmtDate = (d) =>
//   new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

// const CHUNK = 3;
// const chunk = (arr, n) => {
//   const out = [];
//   for (let i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
//   return out;
// };

// // ── Main component ────────────────────────────────────────────────────────────
// const CouponSection = () => {
//   const [coupons, setCoupons]     = useState([]);
//   const [loading, setLoading]     = useState(true);
//   const [activeIdx, setActiveIdx] = useState(0);

//   const touchStartX = useRef(null);
//   const isSwiping   = useRef(false);

//   // Fetch
//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await axios.get(
//           "https://api.carnivalcastle.com/v1/carnivalApi/admin/coupon/getallcarnivalcoupons"
//         );
//         if (res.data.success) {
//           const now   = new Date();
//           const valid = res.data.coupons.filter((c) => {
//             const exp = new Date(c.toDate);
//             return c.status === "active" && exp >= now && !isNaN(exp.getTime());
//           });
//           setCoupons(valid);
//         }
//       } catch (err) {
//         console.error("Error fetching coupons:", err);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   const pages = chunk(coupons, CHUNK);

//   // Auto-advance
//   useEffect(() => {
//     if (pages.length <= 1) return;
//     const t = setInterval(() => setActiveIdx((i) => (i + 1) % pages.length), 4500);
//     return () => clearInterval(t);
//   });

//   const prev = () => setActiveIdx((i) => (i - 1 + pages.length) % pages.length);
//   const next = () => setActiveIdx((i) => (i + 1) % pages.length);

//   const copy = (code) => {
//     navigator.clipboard.writeText(code);
//     toast.success(`Code "${code}" copied!`, {
//       position: "top-center",
//       autoClose: 1600,
//       style: { background: C.purple, color: C.gold, fontWeight: 700 },
//     });
//   };

//   // Touch
//   const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; isSwiping.current = false; };
//   const onTouchMove  = (e) => {
//     if (!touchStartX.current) return;
//     if (Math.abs(e.touches[0].clientX - touchStartX.current) > 8) { isSwiping.current = true; e.preventDefault(); }
//   };
//   const onTouchEnd = (e) => {
//     if (!touchStartX.current) return;
//     const dx = e.changedTouches[0].clientX - touchStartX.current;
//     if (isSwiping.current && Math.abs(dx) > 40) dx < 0 ? next() : prev();
//     touchStartX.current = null; isSwiping.current = false;
//   };

//   // ── States ──────────────────────────────────────────────────────────────────
//   if (loading) return (
//     <section style={sectionStyle}>
//       <div style={{ textAlign: "center", padding: "60px 0" }}>
//         <div style={{ width: 44, height: 44, border: `3px solid ${C.gold}`, borderTopColor: "transparent",
//           borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
//         <p style={{ color: C.muted, fontFamily: "'DM Sans', sans-serif" }}>Finding best deals for you…</p>
//       </div>
//       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//     </section>
//   );

//   if (coupons.length === 0) return (
//     <section style={sectionStyle}>
//       <div className="container">
//         <SectionHeader />
//         <div style={{ textAlign: "center", padding: "40px 0" }}>
//           <div style={{ display: "inline-block", padding: "40px 56px", borderRadius: 20,
//             background: C.violetSoft, border: `1px solid rgba(255,215,0,0.2)` }}>
//             <FaTicketAlt size={48} color={C.gold} style={{ opacity: 0.5 }} />
//             <p style={{ color: C.muted, marginTop: 16, fontFamily: "'DM Sans', sans-serif" }}>
//               No active coupons right now.<br />Check back soon for exciting deals!
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );

//   // ── Main render ─────────────────────────────────────────────────────────────
//   return (
//     <section style={sectionStyle}>
//       <div className="container">
//         <SectionHeader />

//         {/* Dots */}
//         {pages.length > 1 && (
//           <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 36 }}>
//             {pages.map((_, i) => (
//               <button key={i} onClick={() => setActiveIdx(i)} style={{
//                 width: i === activeIdx ? 28 : 10, height: 10, borderRadius: 999,
//                 border: "none", padding: 0, cursor: "pointer",
//                 background: i === activeIdx ? C.gold : "rgba(255,215,0,0.25)",
//                 transition: "all .3s ease",
//               }} />
//             ))}
//           </div>
//         )}

//         {/* Slider */}
//         <div style={{ position: "relative", overflow: "hidden" }}
//           onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>

//           <div style={{
//             display: "flex",
//             transform: `translateX(-${activeIdx * 100}%)`,
//             transition: "transform .5s cubic-bezier(.34,1.26,.64,1)",
//             willChange: "transform",
//           }}>
//             {pages.map((page, pi) => (
//               <div key={pi} style={{ minWidth: "100%", flexShrink: 0 }}>
//                 <div className="row g-4 justify-content-center">
//                   {page.map((coupon) => (
//                     <div key={coupon._id} className="col-md-4 d-flex justify-content-center">
//                       <CouponCard coupon={coupon} onCopy={copy} />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Arrows */}
//           {pages.length > 1 && (
//             <>
//               <ArrowBtn dir="left"  onClick={prev} />
//               <ArrowBtn dir="right" onClick={next} />
//             </>
//           )}
//         </div>
//       </div>

//       <ToastContainer />
//       <Styles />
//     </section>
//   );
// };

// // ── Sub-components ────────────────────────────────────────────────────────────

// const SectionHeader = () => (
//   <div style={{ textAlign: "center", marginBottom: 36 }}>
//     <span style={{
//       background: C.gold, color: C.dark, fontSize: 10, fontWeight: 800,
//       letterSpacing: 2, textTransform: "uppercase", padding: "5px 14px",
//       borderRadius: 50, display: "inline-block", marginBottom: 14,
//     }}>
//       🎁 Exclusive Deals
//     </span>
//     <h2 style={{
//       fontFamily: "'Playfair Display', serif", fontSize: "clamp(28px,4vw,42px)",
//       fontWeight: 900, color: C.white, lineHeight: 1.15, margin: 0,
//     }}>
//       CarnivalCastle <span style={{ color: C.gold }}>Coupons</span>
//     </h2>
//     <p style={{ color: C.muted, fontFamily: "'DM Sans', sans-serif", marginTop: 8 }}>
//       Copy a code · Use at checkout · Save instantly
//     </p>
//   </div>
// );

// const CouponCard = ({ coupon, onCopy }) => {
//   const isFixed   = coupon.discountType === "fixed";
//   const discount  = isFixed ? `₹${coupon.value}` : `${coupon.value}%`;
//   const theaters  = coupon.theaters?.map((t) => t.name).join(", ") || "All Theaters";
//   const slots     = coupon.slots?.join(", ") || "All Slots";

//   return (
//     <div className="cc-coupon-card">
//       {/* Top ribbon */}
//       <div style={{
//         background: `linear-gradient(135deg, ${C.gold}, ${C.goldLight})`,
//         padding: "10px 20px",
//         display: "flex", alignItems: "center", justifyContent: "space-between",
//       }}>
//         <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 800,
//           letterSpacing: 1.5, textTransform: "uppercase", color: C.dark }}>
//           🏷️ {isFixed ? "Flat Discount" : "Percent Off"}
//         </span>
//         <span style={{ fontFamily: "'Playfair Display',serif", fontSize: 22,
//           fontWeight: 900, color: C.dark }}>
//           {discount} <span style={{ fontSize: 13 }}>OFF</span>
//         </span>
//       </div>

//       {/* Body */}
//       <div style={{ padding: "20px 22px 18px" }}>
//         {/* Title + ring */}
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
//           <div style={{ flex: 1, paddingRight: 12 }}>
//             <h5 style={{ fontFamily: "'Playfair Display',serif", fontWeight: 800,
//               color: C.white, fontSize: 17, margin: "0 0 6px" }}>
//               {coupon.title}
//             </h5>
//             <p style={{ fontFamily: "'DM Sans',sans-serif", color: C.muted,
//               fontSize: 12.5, lineHeight: 1.5, margin: 0 }}>
//               {coupon.description || "Special offer for you!"}
//             </p>
//           </div>
//           {/* Mini ring */}
//           <div style={{
//             width: 64, height: 64, borderRadius: "50%", flexShrink: 0,
//             background: `conic-gradient(${C.gold} 0%, ${C.goldLight} 40%, ${C.violetSoft} 40%)`,
//             display: "flex", alignItems: "center", justifyContent: "center",
//             boxShadow: `0 0 0 3px ${C.goldDim}, 0 0 0 6px ${C.violetSoft}`,
//           }}>
//             <div style={{
//               width: 48, height: 48, borderRadius: "50%",
//               background: C.purpleMid,
//               display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
//             }}>
//               <span style={{ fontFamily: "'Playfair Display',serif", fontSize: 16,
//                 fontWeight: 900, color: C.gold, lineHeight: 1 }}>{discount}</span>
//               <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 8,
//                 color: C.muted, textTransform: "uppercase", letterSpacing: 1 }}>OFF</span>
//             </div>
//           </div>
//         </div>

//         {/* Dashed divider */}
//         <div style={{ borderTop: `1.5px dashed rgba(255,215,0,0.25)`, margin: "14px 0" }} />

//         {/* Meta info */}
//         <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
//           <MetaRow icon={<FaCalendarAlt />} label="Valid Till" value={new Date(coupon.toDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })} />
//           <MetaRow icon={<FaMapMarkerAlt />} label="Theaters"  value={theaters} />
//           <MetaRow icon={<FaClock />}        label="Slots"     value={slots} />
//         </div>

//         {/* Code chip + Copy button */}
//         <div style={{ display: "flex", gap: 10, alignItems: "stretch" }}>
//           <div style={{
//             flex: 1, background: C.goldDim, border: `1.5px dashed ${C.gold}`,
//             borderRadius: 10, padding: "10px 14px", display: "flex",
//             flexDirection: "column", justifyContent: "center",
//           }}>
//             <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 10,
//               color: C.muted, textTransform: "uppercase", letterSpacing: 1.2 }}>Coupon Code</span>
//             <span style={{ fontFamily: "'Playfair Display',serif", fontSize: 18,
//               fontWeight: 900, color: C.gold, letterSpacing: 2 }}>{coupon.couponCode}</span>
//           </div>
//           <button className="cc-copy-btn" onClick={() => onCopy(coupon.couponCode)}>
//             <FaCopy size={14} />
//             <span>Copy</span>
//           </button>
//         </div>
//       </div>

//       {/* Perforation notches */}
//       <div className="cc-notch cc-notch--left"  />
//       <div className="cc-notch cc-notch--right" />
//     </div>
//   );
// };

// const MetaRow = ({ icon, label, value }) => (
//   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
//     <span style={{ display: "flex", alignItems: "center", gap: 6,
//       fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: C.muted, whiteSpace: "nowrap" }}>
//       <span style={{ color: C.gold, fontSize: 11 }}>{icon}</span>
//       {label}
//     </span>
//     <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12,
//       color: C.offWhite, textAlign: "right", maxWidth: 160 }}>{value}</span>
//   </div>
// );

// const ArrowBtn = ({ dir, onClick }) => (
//   <button onClick={onClick} style={{
//     position: "absolute", top: "50%", [dir === "left" ? "left" : "right"]: -8,
//     transform: "translateY(-50%)", width: 36, height: 36, borderRadius: "50%",
//     background: `linear-gradient(135deg, ${C.gold}, ${C.goldLight})`,
//     border: "none", cursor: "pointer", display: "flex",
//     alignItems: "center", justifyContent: "center",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.4)", zIndex: 10,
//   }}>
//     {dir === "left" ? <FaChevronLeft color={C.dark} size={13} /> : <FaChevronRight color={C.dark} size={13} />}
//   </button>
// );

// // ── Static styles ─────────────────────────────────────────────────────────────
// const sectionStyle = {
//   background: `linear-gradient(160deg, ${C.dark} 0%, ${C.purple} 60%, ${C.dark} 100%)`,
//   padding: "72px 0",
//   position: "relative",
//   overflow: "hidden",
// };

// const Styles = () => (
//   <style>{`
//     .cc-coupon-card {
//       width: 100%;
//       max-width: 340px;
//       background: linear-gradient(160deg, ${C.purpleMid} 0%, ${C.purple} 100%);
//       border: 1px solid rgba(255,215,0,0.22);
//       border-radius: 16px;
//       overflow: hidden;
//       position: relative;
//       transition: transform 0.3s ease, box-shadow 0.3s ease;
//       box-shadow: 0 8px 32px rgba(0,0,0,0.45);
//     }
//     .cc-coupon-card:hover {
//       transform: translateY(-6px) scale(1.015);
//       box-shadow: 0 18px 48px rgba(0,0,0,0.55), 0 0 0 1px rgba(255,215,0,0.35);
//     }
//     .cc-notch {
//       position: absolute;
//       top: 50%;
//       transform: translateY(-50%);
//       width: 18px;
//       height: 18px;
//       border-radius: 50%;
//       background: ${C.dark};
//       border: 1px solid rgba(255,215,0,0.2);
//     }
//     .cc-notch--left  { left:  -9px; }
//     .cc-notch--right { right: -9px; }
//     .cc-copy-btn {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justify-content: center;
//       gap: 3px;
//       padding: 0 18px;
//       border-radius: 10px;
//       border: none;
//       cursor: pointer;
//       background: linear-gradient(135deg, ${C.gold}, ${C.goldLight});
//       color: ${C.dark};
//       font-family: 'DM Sans', sans-serif;
//       font-size: 11px;
//       font-weight: 800;
//       letter-spacing: 0.5px;
//       text-transform: uppercase;
//       transition: transform 0.15s, box-shadow 0.15s;
//       white-space: nowrap;
//     }
//     .cc-copy-btn:hover {
//       transform: scale(1.06);
//       box-shadow: 0 4px 14px rgba(255,215,0,0.35);
//     }
//     .cc-copy-btn:active { transform: scale(0.97); }
//   `}</style>
// );

// export default CouponSection;

import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaCopy, FaCalendarAlt, FaMapMarkerAlt, FaClock } from "react-icons/fa";

/* ── palette matches site CSS vars ─────────────────────────────────────── */
const C = {
  dark:    "#1A0030",
  dark2:   "#120020",
  p:       "#5E0E73",
  pl:      "#6E1A85",
  gold:    "#C9A84C",
  gl:      "#E8D5A0",
  cream:   "#E8E1D6",
};

/* ── helpers ────────────────────────────────────────────────────────────── */
const fmtDate = d => new Date(d).toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric" });
const chunkArr = (arr, n) => { const out=[]; for(let i=0;i<arr.length;i+=n) out.push(arr.slice(i,i+n)); return out; };
const CHUNK = 3;

/* ══════════════════════════════════════════════════════════════════════════
   CouponCard — styled like the cc-offer banner
══════════════════════════════════════════════════════════════════════════ */
const CouponCard = ({ coupon, onCopy }) => {
  const isFixed  = coupon.discountType === "fixed";
  const discount = isFixed ? `₹${coupon.value}` : `${coupon.value}%`;
  const theaters = coupon.theaters?.map(t => t.name).join(", ") || "All Theaters";
  const slots    = coupon.slots?.join(", ") || "All Slots";

  return (
    <div className="cc-coupon-wrap">
      {/* glow ring — decorative, mirrors .cc-ring from OfferBanner */}
      <div className="cc-coupon-ring">
        {/* <span className="cc-coupon-ring-disc">{discount}<small>OFF</small></span> */}
      </div>

      {/* main card body — same gradient as .cc-offer */}
      <div className="cc-coupon-body">
        {/* header row */}
        <div className="cc-coupon-header">
          <span className="cc-coupon-badge">
            🏷️ {isFixed ? "Flat Discount" : "Percent Off"}
          </span>
          <span className="cc-coupon-disc-lbl">{discount} <small>OFF</small></span>
        </div>

        {/* title + description */}
        <h3 className="cc-coupon-title pf">{coupon.title}</h3>
        <p className="cc-coupon-desc">{coupon.description || "Special offer — grab it before it's gone!"}</p>

        {/* divider — same dashed line as cc-offer-code */}
        <div className="cc-coupon-dash" />

        {/* meta rows */}
        <div className="cc-coupon-meta">
          <MetaRow icon={<FaCalendarAlt />} label="Valid Till" value={fmtDate(coupon.toDate)} />
          <MetaRow icon={<FaMapMarkerAlt />} label="Theaters"  value={theaters} />
          <MetaRow icon={<FaClock />}        label="Slots"     value={slots} />
        </div>

        {/* code chip + copy — exactly like .cc-offer-code */}
        <div className="cc-coupon-code-row">
          <div className="cc-offer-code">
            🏷️ Use Code: <b>{coupon.couponCode}</b>
          </div>
          <button className="cc-coupon-copy-btn" onClick={() => onCopy(coupon.couponCode)}>
            <FaCopy size={12} /> Copy
          </button>
        </div>
      </div>

      {/* ticket notches */}
      <span className="cc-coupon-notch cc-coupon-notch--l" />
      <span className="cc-coupon-notch cc-coupon-notch--r" />
    </div>
  );
};

const MetaRow = ({ icon, label, value }) => (
  <div className="cc-coupon-meta-row">
    <span className="cc-coupon-meta-label">
      <span style={{ color:C.gold, marginRight:6 }}>{icon}</span>{label}
    </span>
    <span className="cc-coupon-meta-val">{value}</span>
  </div>
);

/* ══════════════════════════════════════════════════════════════════════════
   Main CouponSection
══════════════════════════════════════════════════════════════════════════ */
const CouponSection = () => {
  const [coupons,    setCoupons]    = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [activeIdx,  setActiveIdx]  = useState(0);
  const touchStartX  = useRef(null);
  const isSwiping    = useRef(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get("https://api.carnivalcastle.com/v1/carnivalApi/admin/coupon/getallcarnivalcoupons");
        if (res.data.success) {
          const now   = new Date();
          const valid = res.data.coupons.filter(c => {
            const exp = new Date(c.toDate);
            return c.status === "active" && exp >= now && !isNaN(exp.getTime());
          });
          setCoupons(valid);
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, []);

  const pages = chunkArr(coupons, CHUNK);

  useEffect(() => {
    if (pages.length <= 1) return;
    const t = setInterval(() => setActiveIdx(i => (i + 1) % pages.length), 4500);
    return () => clearInterval(t);
  });

  const prev = useCallback(() => setActiveIdx(i => (i - 1 + pages.length) % pages.length), [pages.length]);
  const next = useCallback(() => setActiveIdx(i => (i + 1) % pages.length),              [pages.length]);

  const copy = code => {
    navigator.clipboard.writeText(code);
    toast.success(`Code "${code}" copied!`, { position:"top-center", autoClose:1600,
      style:{ background:C.p, color:C.gl, fontWeight:700 } });
  };

  const onTouchStart = e => { touchStartX.current = e.touches[0].clientX; isSwiping.current = false; };
  const onTouchMove  = e => { if(!touchStartX.current) return; if(Math.abs(e.touches[0].clientX - touchStartX.current)>8){ isSwiping.current=true; e.preventDefault(); } };
  const onTouchEnd   = e => { if(!touchStartX.current) return; const dx=e.changedTouches[0].clientX-touchStartX.current; if(isSwiping.current&&Math.abs(dx)>40) dx<0?next():prev(); touchStartX.current=null; isSwiping.current=false; };

  /* ── loading ── */
  if (loading) return (
    <section className="cc-coupon-sec">
      <div style={{ textAlign:"center", padding:"64px 0" }}>
        <div className="cc-coupon-spinner" />
        <p style={{ color:"rgba(255,255,255,.45)", fontFamily:"'DM Sans',sans-serif", marginTop:16 }}>Finding best deals…</p>
      </div>
      <Styles/>
    </section>
  );

  /* ── empty ── */
  if (!coupons.length) return (
    <section className="cc-coupon-sec">
      <div className="container">
        <SectionHeader />
        <div style={{ textAlign:"center", padding:"40px 0" }}>
          <div className="cc-coupon-empty">
            <span style={{ fontSize:48, opacity:.5 }}>🎟️</span>
            <p style={{ color:"rgba(255,255,255,.45)", marginTop:16 }}>No active coupons right now.<br/>Check back soon for exciting deals!</p>
          </div>
        </div>
      </div>
      <Styles/>
    </section>
  );

  /* ── main ── */
  return (
    <section className="cc-coupon-sec">
      {/* decorative orbs */}
      <div className="cc-coupon-orb cc-coupon-orb--a" />
      <div className="cc-coupon-orb cc-coupon-orb--b" />

      <div className="container" style={{ position:"relative", zIndex:1 }}>
        <SectionHeader />

        {/* dots */}
        {pages.length > 1 && (
          <div style={{ display:"flex", justifyContent:"center", gap:8, marginBottom:36 }}>
            {pages.map((_,i) => (
              <button key={i} onClick={() => setActiveIdx(i)} style={{
                width: i===activeIdx ? 28 : 10, height:10, borderRadius:999,
                border:"none", padding:0, cursor:"pointer",
                background: i===activeIdx ? C.gold : "rgba(201,168,76,.25)",
                transition:"all .3s ease",
              }}/>
            ))}
          </div>
        )}

        {/* slider */}
        <div style={{ position:"relative", overflow:"hidden" }}
          onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>

          <div style={{ display:"flex", transform:`translateX(-${activeIdx*100}%)`, transition:"transform .5s cubic-bezier(.34,1.26,.64,1)", willChange:"transform" }}>
            {pages.map((page, pi) => (
              <div key={pi} style={{ minWidth:"100%", flexShrink:0 }}>
                <div className="row g-4 justify-content-center">
                  {page.map(coupon => (
                    <div key={coupon._id} className="col-lg-4 col-md-6 d-flex justify-content-center">
                      <CouponCard coupon={coupon} onCopy={copy} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* arrows */}
          {pages.length > 1 && <>
            <button className="cc-coupon-arrow cc-coupon-arrow--l" onClick={prev}>‹</button>
            <button className="cc-coupon-arrow cc-coupon-arrow--r" onClick={next}>›</button>
          </>}
        </div>
      </div>

      <ToastContainer/>
      <Styles/>
    </section>
  );
};

/* ── Section header ─────────────────────────────────────────────────────── */
const SectionHeader = () => (
  <div style={{ textAlign:"center", marginBottom:44 }}>
    <span style={{ background:C.gold, color:C.dark, fontSize:10, fontWeight:800, letterSpacing:2,
      textTransform:"uppercase", padding:"5px 14px", borderRadius:50, display:"inline-block", marginBottom:14 }}>
      🎁 Exclusive Deals
    </span>
    <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(28px,4vw,44px)",
      fontWeight:900, color:"#fff", lineHeight:1.15, margin:"0 0 10px" }}>
      CarnivalCastle <span style={{ background:`linear-gradient(135deg,${C.gl},${C.cream})`,
        WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>Coupons</span>
    </h2>
    <p style={{ color:"rgba(255,255,255,.5)", fontFamily:"'DM Sans',sans-serif", margin:0 }}>
      Copy a code · Use at checkout · Save instantly
    </p>
  </div>
);

/* ── CSS ────────────────────────────────────────────────────────────────── */
const Styles = () => (
  <style>{`
    @keyframes spinslow { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
    @keyframes cc-spin   { to { transform: rotate(360deg); } }
    @keyframes cc-goldBg { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }

    /* ── section ── */
    .cc-coupon-sec {
      position: relative;
      overflow: hidden;
      background: linear-gradient(135deg, ${C.dark} 0%, ${C.p} 55%, ${C.dark} 100%);
      padding: 72px 0;
    }
    .cc-coupon-sec::before {
      content:'';
      position:absolute; inset:0;
      background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
      pointer-events: none;
    }
    .cc-coupon-orb {
      position: absolute; border-radius: 50%;
      filter: blur(80px); pointer-events: none;
    }
    .cc-coupon-orb--a {
      width: 420px; height: 420px;
      background: radial-gradient(circle, rgba(201,168,76,.14) 0%, transparent 70%);
      top: -80px; right: -60px;
    }
    .cc-coupon-orb--b {
      width: 320px; height: 320px;
      background: radial-gradient(circle, rgba(94,14,115,.25) 0%, transparent 70%);
      bottom: -60px; left: -40px;
    }

    /* ── card wrapper — mirrors .cc-offer ── */
    .cc-coupon-wrap {
      width: 100%;
      max-width: 360px;
      position: relative;
      border-radius: 22px;
      overflow: hidden;
      background: linear-gradient(135deg, ${C.dark} 0%, ${C.p} 55%, ${C.dark} 100%);
      border: 1px solid rgba(201,168,76,.25);
      box-shadow: 0 20px 60px rgba(94,14,115,.45);
      transition: transform .35s cubic-bezier(.25,1,.5,1), box-shadow .35s;
    }
    .cc-coupon-wrap:hover {
      transform: translateY(-8px) scale(1.015);
      box-shadow: 0 32px 80px rgba(94,14,115,.55);
    }

    /* ── spinning ring — exact clone of .cc-ring ── */
    .cc-coupon-ring {
      position: absolute;
      top: -50px; right: -50px;
      width: 175px; height: 175px;
      border-radius: 50%;
      border: 1.5px solid rgba(201,168,76,.3);
      display: flex; align-items: center; justify-content: center; flex-direction: column;
      animation: spinslow 20s linear infinite;
      background: rgba(201,168,76,.07);
      pointer-events: none;
      z-index: 0;
    }
    .cc-coupon-ring-disc {
      font-family: 'Playfair Display', serif;
      font-size: 38px; font-weight: 900;
      color: ${C.gold};
      line-height: 1;
      display: flex; flex-direction: column; align-items: center;
      animation: spinslow 20s linear infinite reverse; /* counter-rotate so text stays upright */
    }
    .cc-coupon-ring-disc small {
      font-size: 11px; color: rgba(255,255,255,.45);
      text-transform: uppercase; letter-spacing: 1px;
      margin-top: 2px;
    }

    /* ── body ── */
    .cc-coupon-body {
      padding: 28px 26px 24px;
      position: relative; z-index: 1;
    }

    /* header row */
    .cc-coupon-header {
      display: flex; align-items: center; justify-content: space-between;
      margin-bottom: 14px;
    }
    .cc-coupon-badge {
      font-family: 'DM Sans', sans-serif;
      font-size: 10px; font-weight: 800;
      letter-spacing: 1.5px; text-transform: uppercase;
      color: ${C.dark};
      background: linear-gradient(135deg, ${C.gold}, ${C.gl});
      padding: 4px 12px; border-radius: 50px;
    }
    .cc-coupon-disc-lbl {
      font-family: 'Playfair Display', serif;
      font-size: 22px; font-weight: 900;
      background: linear-gradient(135deg, ${C.gl}, ${C.cream});
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      white-space: nowrap;
    }
    .cc-coupon-disc-lbl small { font-size: 13px; }

    /* title — mirrors .cc-offer-h */
    .cc-coupon-title {
      font-size: clamp(20px,3vw,26px);
      font-weight: 900; color: #fff;
      line-height: 1.1; margin-bottom: 8px;
    }
    .cc-coupon-desc {
      font-family: 'DM Sans', sans-serif;
      font-size: 13px; color: rgba(255,255,255,.6);
      line-height: 1.6; margin-bottom: 0;
    }

    /* dashed divider */
    .cc-coupon-dash {
      border-top: 1.5px dashed rgba(201,168,76,.35);
      margin: 18px 0;
    }

    /* meta rows */
    .cc-coupon-meta { display: flex; flex-direction: column; gap: 8px; margin-bottom: 18px; }
    .cc-coupon-meta-row {
      display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;
    }
    .cc-coupon-meta-label {
      font-family: 'DM Sans', sans-serif; font-size: 12px;
      color: rgba(255,255,255,.5); white-space: nowrap;
      display: flex; align-items: center;
    }
    .cc-coupon-meta-val {
      font-family: 'DM Sans', sans-serif; font-size: 12px;
      color: rgba(255,255,255,.85); text-align: right; max-width: 180px;
    }

    /* code row — uses existing .cc-offer-code from styles.css */
    .cc-coupon-code-row {
      display: flex; align-items: center; gap: 10px;
    }
    /* extend existing .cc-offer-code to flex-1 inside the row */
    .cc-coupon-code-row .cc-offer-code {
      flex: 1; font-size: 13px;
    }
    .cc-coupon-copy-btn {
      display: inline-flex; align-items: center; gap: 5px;
      padding: 10px 16px; border-radius: 10px; border: none;
      cursor: pointer;
      background: linear-gradient(135deg, #B8860B, ${C.gold}, ${C.gl}, ${C.gold}, #9A6E10);
      background-size: 200% 200%; animation: cc-goldBg 3s ease infinite;
      color: ${C.dark};
      font-family: 'DM Sans', sans-serif; font-size: 12px; font-weight: 800;
      letter-spacing: .5px; text-transform: uppercase;
      transition: transform .15s, box-shadow .15s;
      white-space: nowrap;
    }
    .cc-coupon-copy-btn:hover { transform: scale(1.06); box-shadow: 0 4px 14px rgba(201,168,76,.4); }

    /* ticket notches */
    .cc-coupon-notch {
      position: absolute; top: 50%;
      width: 20px; height: 20px; border-radius: 50%;
      background: linear-gradient(135deg, ${C.dark}, ${C.dark2});
      border: 1px solid rgba(201,168,76,.18);
      transform: translateY(-50%);
    }
    .cc-coupon-notch--l { left: -10px; }
    .cc-coupon-notch--r { right: -10px; }

    /* arrows */
    .cc-coupon-arrow {
      position: absolute; top: 50%;
      transform: translateY(-50%);
      width: 38px; height: 38px; border-radius: 50%;
      background: linear-gradient(135deg, ${C.gold}, ${C.gl});
      border: none; cursor: pointer; z-index: 10;
      font-size: 20px; font-weight: 700; color: ${C.dark};
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 4px 14px rgba(0,0,0,.4);
      transition: transform .2s;
    }
    .cc-coupon-arrow:hover { transform: translateY(-50%) scale(1.1); }
    .cc-coupon-arrow--l { left: -4px; }
    .cc-coupon-arrow--r { right: -4px; }

    /* spinner */
    .cc-coupon-spinner {
      width: 44px; height: 44px;
      border: 3px solid rgba(201,168,76,.25);
      border-top-color: ${C.gold};
      border-radius: 50%;
      animation: cc-spin .8s linear infinite;
      margin: 0 auto;
    }

    /* empty box */
    .cc-coupon-empty {
      display: inline-block; padding: 48px 56px;
      border-radius: 20px;
      background: rgba(94,14,115,.18);
      border: 1px solid rgba(201,168,76,.2);
    }

    /* mobile */
    @media(max-width:640px) {
      .cc-coupon-wrap { max-width: 100%; }
      .cc-coupon-ring { display: none; }
    }
  `}</style>
);

export default CouponSection;